import {
    URLAPI,
    REASON_SHIPPING_REQUEST_PATH,
    REASON_SHIPPING_REQUEST_CREATE_PATH,
    REASON_SHIPPING_REQUEST_UPDATE_PATH,
    REASON_SHIPPING_REQUEST_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_reason_shipping_request: {
        data: [],

        status: 0,
        message: {},
    },

    _create_reason_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
    _update_reason_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_reason_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_REASON_SHIPPING_REQUEST = "GET_ALL_REASON_SHIPPING_REQUEST";
export const CREATE_REASON_SHIPPING_REQUEST = "CREATE_REASON_SHIPPING_REQUEST";
export const UPDATE_REASON_SHIPPING_REQUEST = "UPDATE_REASON_SHIPPING_REQUEST";
export const DELETE_REASON_SHIPPING_REQUEST = "DELETE_REASON_SHIPPING_REQUEST";

export const reason_shipping_request_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_REASON_SHIPPING_REQUEST:
            return {
                ...state,
                _get_all_reason_shipping_request: action.payload,
            };
        case CREATE_REASON_SHIPPING_REQUEST:
            return {
                ...state,
                _create_reason_shipping_request: action.payload,
            };
        case UPDATE_REASON_SHIPPING_REQUEST:
            return {
                ...state,
                _update_reason_shipping_request: action.payload,
            };
        case DELETE_REASON_SHIPPING_REQUEST:
            return {
                ...state,
                _delete_reason_shipping_request: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllReasonShippingRequest = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${REASON_SHIPPING_REQUEST_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_REASON_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_REASON_SHIPPING_REQUEST,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_REASON_SHIPPING_REQUEST,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createReasonShippingRequest = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${REASON_SHIPPING_REQUEST_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_REASON_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_REASON_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_REASON_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateReasonShippingRequest = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${REASON_SHIPPING_REQUEST_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_REASON_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_REASON_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_REASON_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteReasonShippingRequest = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${REASON_SHIPPING_REQUEST_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_REASON_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_REASON_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_REASON_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_reason_shipping_request = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
